<template>
  <div id="app" v-cloak>
    <router-view></router-view>
  </div>
</template>
<script>
import { getToken } from "@/utils/auth"
import {getQueryString} from "@/utils/index"
export default {
  name: "App",
  data() {
    return {
      isOpenid: this.$store.getters.isOpenid,
      focusShow: false,
      timerFn: null,
      printerStatus: 0,//打印机是否连接
      alertShow: false,
      alertBox: null,
    };
  },
  watch: {
    "$store.state.app.isLogin": {
      handler: function (newVal) {
        console.log('token-change');
        if(newVal == 1){
          this.checkPrinterStatus()
        }else{
          clearInterval(this.timerFn)
        }
      },
    },
    printerStatus(nowVal, oldVal) {
      console.log(nowVal, oldVal, 'p-s-chaneg');
      clearInterval(this.timerFn)
      this.checkPrinterStatus()
    }
  },
  created() {
    sessionStorage.getItem('umeetCloudVuex') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(sessionStorage.getItem('umeetCloudVuex'))));
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('umeetCloudVuex', JSON.stringify(this.$store.state))
    })



    this.$store.dispatch('app/setIslogin', getToken() ? 1 : 0);
    // http://192.168.3.8:8080/#/login?aa=1

    if (getToken()) {
      this.printerStatusFn()
    } else {
      clearInterval(this.timerFn)
    }

    console.log(getQueryString('aa'),'a2');
    



  },
  methods: {
    checkPrinterStatus() {
      return
      let login = this.$store.state.app.isLogin;
      clearInterval(this.timerFn)
      let t = 0
      if (login == 1 && localStorage.getItem('code')) { //登录状态下并且有窗口，校验是否连接打印机
        if (this.printerStatus == 1) {
          // t = 5 * 6000;
          t = 10000;
        } else {
          t = 5000
        }
        this.timerFn = setInterval(() => {
          this.printerStatusFn()
        }, t);
      }

    },
    printerStatusFn() {
      this.api.getUrl('/api/v1/window/printerStatus').then(res => {
        if (res) {
          this.printerStatus = res.status;
          if (this.printerStatus == 0) {
            if (!this.alertShow) {
              this.alertShow = true;
              this.alertBox = this.$alert('<strong style="color:#ed2222;">打印机没有连接</strong>', '注意！', {
                dangerouslyUseHTMLString: true,
                showClose: false
              }).then(() => {
                this.alertShow = false;
              });
            }

          }
          if (this.alertShow && this.printerStatus == 1) {
            // this.alertBox.close()
          }
        } else {
          clearInterval(this.timerFn)
        }
      },(res)=>{
        clearInterval(this.timerFn)
      })
    },
    getSystemInfo() {
      // if(this.$route.path == '/login' || this.$route.path == '/memberLucky') return
      console.log('App.vue--');
      this.api.system_index().then((res) => { //获取系统配置

      });
    },
    closeFocusPop() {
      this.focusShow = false;
    }
  },
  components: {
  },
};
</script>

<style lang="scss">
.el-message-box__message strong {
  font-size: 20px;
}

@import url("../src/assets/css/reset.css");

html {
  font-size: calc(100vw / 7.5);
}

// @media screen and (min-width: 576px) {
//   html {
//     font-size: calc(576px / 7.5);
//   }
// }
#app {
  background: #F5F7FA;
}

[v-cloak] {
  display: none;
}

.van-tabbar-item__icon .van-info {
  background: #f9647d;
}
.el-input__inner{
  border: 2px solid #aaa;
}
.el-input-number__increase, .el-input-number__decrease{
  font-size: 16px;
}
.el-input-number__increase, .el-input-number__decrease{
  background: #eee;
}
.el-radio__inner{
  width: 20px;
  height: 20px;
}
.el-radio__inner::after{
  width: 8px;
  height: 8px;
}
.el-input-number__increase{
  
}
</style>
<style>
.other-form .el-form-item__label {
  color: #666;
  font-weight: 400;
}

.el-drawer.rtl {
  overflow: scroll;
}

.el-input__inner:focus {
  border-color: #aaa
}

.el-form-item__label {
  color: #666;
  font-weight: normal;
}

.el-drawer {
  background: #F5F7FA;
}

.el-dialog__body {
  font-size: 16px;
}

.el-radio__input.is-checked+.el-radio__label {
  color: #606266;
}

.el-date-editor .el-range-separator {
  width: 7%;
}

/* .el-radio__original {
  display: none !important;
} */
.el-icon-circle-close {
  color: #fff;
}

.el-progress__text {
  font-size: 13px !important;
}

.el-tabs__item {
  font-size: 15px;
}
</style>